<template>
    <div :class="classes">
        <a class="Accordion__section-toggle" @click="toggle"></a>
        <div class="Accordion__section-heading"@click="toggle">{{ name }}</div>
        <div class="Accordion__section-body" v-show="open">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                open: false,
            }
        },

        props: {
            name: {
                required: true,
                type: String,
            },

            openByDefault: {
                default: false,
                type: Boolean,
            }
        },

        mounted() {
            if (this.openByDefault) {
                this.open = true;
            }
        },

        computed: {
            classes() {
                return {
                    'Accordion__section': true,
                    'Accordion__section--is-open': this.open,
                }
            },
        },

        methods: {
            /**
             * Toggle whether the current accordion section is open
             */
            toggle() {
                // If the section that has been clicked on is open we just need to close it
                if (this.open) {
                    this.open = false;
                } else {
                    // Check if the accordion allows multiple sections to be open and
                    // let the other section know that a new section was opened if not
                    if (! this.$parent.multipleOpen) {
                        _.each(this.$parent.$children, (child) => {
                            child.close();
                        })
                    }

                    this.open = true;
                }

                _.defer(() => {
                    bus.$emit('context-panel-check-scroll');
                })
            },

            close() {
                this.open = false;
            }
        }
    }
</script>